import React from "react";

import EssayGridCell from "./essay-grid-cell";

import "../../styles/essay-grid.scss";

class EssayGrid extends React.Component {
  render() {
    let gridClasses;

    switch (this.props.gridUp) {
      case 2:
        gridClasses = "essay-grid essay-grid__2up";
        break;
      case 3:
        gridClasses = "essay-grid essay-grid__3up";
        break;
      default:
        gridClasses = "essay-grid essay-grid__4up";
        break;
    }

    // if (this.props.singleRow) {
    //   gridClasses += ' single-row-3up';
    // }

    if (this.props.noMargins) {
      gridClasses += ' no-margins';
    }

    return (
      <div className={ gridClasses }>
        {this.props.essayEdges.map(({ node }, idx) => {
          return (
            <EssayGridCell
              key={idx}
              slug={node.data.Slug}
              title={node.data.Title}
              featuredImagePath={node.data.Featured_Image_Path}
              summary={node.data.Intro}
              contributors={node.data.Contributors}
              categories={node.data.Categories}
              series={node.data.Series}
              publishedDate={node.data.Published_Date}
            />
          );
        })} 
      </div>
    );
  }
}

export default EssayGrid;